// extracted by mini-css-extract-plugin
export var wordContainer = "_mu-0";